import { useSelector } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { getNextOffset } from '@wix/da-shared-react/pkg/Stream/withOffset/selectors';
import {
  hasMore as getHasMore,
  getHasLess,
} from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { STUDIO_DEVIATIONS_STREAM } from '../../constants';
import { getPageSize } from '../selectors/studio';

export function usePageOffsets(selectedFolder?: PapiGallection) {
  const { streamId } = STUDIO_DEVIATIONS_STREAM;

  const pageSize = useSelector(getPageSize);
  const nextOffset = useSelector(state => getNextOffset(state, streamId));
  const hasMore = useSelector(state => getHasMore(state, streamId));
  const hasLess = useSelector(state => getHasLess(state, streamId));

  if (!selectedFolder) {
    return {};
  }
  const { size } = selectedFolder;

  let thisOffset, nextPage;
  if (!hasLess) {
    // First page
    thisOffset = 0;
  } else if (!hasMore) {
    // Last page, offset is the last whole number of pages
    thisOffset = size - (size % pageSize);
  } else {
    thisOffset = nextOffset - pageSize;
  }

  if (thisOffset + pageSize > size) {
    // Last page, "next" is the end of the stream
    nextPage = size;
  } else {
    nextPage = thisOffset + pageSize;
  }

  return {
    topOfPage: thisOffset,
    bottomOfPage: nextPage - 1,
  };
}
